import Game from '../../game';

class Pentago extends Game {
  constructor(obj) {
    super(obj);
    if (obj.the_game) {
      obj = this.constructor.deserialize(obj.the_game);
    }
    // game related
    this.sides = obj.sides || ['b', 'w'];
    this.sideNames = obj.sideNames || { b: 'Black', w: 'White' };
    this.n = obj.n || 11;
    this.lastCaptured = obj.lastCaptured || [];
    this.lastPlayed = obj.lastPlayed || [];
    this.askedFor = obj.askedFor || '';
    this.playableSquares = [];
    this.chars = 'abcdefghijklmnopqrstuvxyz';
    this.playSound(this.lastCaptured.length);
  }

  static getNumValues(str) {
    const [row, col] = str.split('_');
    return [Number.parseInt(row, 10), Number.parseInt(col, 10)];
  }

  toNotation(str) {
    const [row, col] = this.helper.getNumValues(str);
    return `${this.chars[col]}${this.n - row}`;
  }

  getNotation({ lastPlayed, lastCaptured = null, gameOver }) {
    const [from, to] = lastPlayed.map(lp => this.toNotation(lp));
    let str = `${from}-${to}`;
    if (lastCaptured && lastCaptured.length > 0) {
      const cn = lastCaptured.map(cp => this.toNotation(cp));
      str += `x${cn.join(' /')}`;
    }
    if (gameOver) {
      str += '++';
    }

    return str;
  }

  move(from, to) {
    const [row, col] = from;
    const [newr, newc] = to;

    const piece = this.board[row][col];
    this.lastPlayed = [`${row}_${col}`, `${newr}_${newc}`];
    this.board[row][col] = ' ';
    this.board[newr][newc] = piece;
    this.playableSquares = [];
    this.askedFor = '';

    if (this.isGameOver()) {
      const notation = this.getNotation({
        lastPlayed: this.lastPlayed,
        gameOver: true,
      });
      const result = this.getTurnPlayerSide() === 'b' ? 'Attackers captured the king' : 'King escaped';
      this.gameOver(this.getTurnPlayerSide(), notation, result);

      return;
    }

    this.beforeTurnChange();
    this.getTurnPlayerInfo().clockStarted = true;
    this.turn += 1;
    this.lastCaptured = this.checkCaptures();
    const notation = this.getNotation({
      lastPlayed: this.lastPlayed,
      lastCaptured: this.lastCaptured,
      gameOver: false,
    });
    this.addMove(notation);
  }

  isGameOver() {
    console.log(this);
    return false;
  }
}

export default Pentago;
